// This import loads the firebase namespace along with all its type information.
import ApprovedMedia from './approved-media-model'

export async function load_approvedMedias(): Promise<ApprovedMedia[]> {
  throw 'Not implemented'
}

export async function delete_approvedMedia(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_approvedMedia(): Promise<ApprovedMedia> {
  throw 'Not implemented'
}
